(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-back"] && !window.DesignMode) return;
  try {
    
  // セレクタ名（.pagetop）に一致する要素を取得
  const pagetop_btn = document.querySelector(".pagetop");
  
  // .pagetopをクリックしたら
  pagetop_btn.addEventListener("click", scroll_top);
  
  // ページ上部へスムーズに移動
  function scroll_top() {
    window.scroll({ top: 0, behavior: "smooth" });
  }
  
  // スクロールされたら表示
  window.addEventListener("scroll", scroll_event);
  function scroll_event() {
    if (window.pageYOffset > 400) {
      pagetop_btn.style.display = "block";
    } else if (window.pageYOffset < 400) {
      pagetop_btn.style.display = "none";
    }
  }

  } catch(e) { console.error(e); }
})();
})();
